import React from 'react';
import { MenuIcon, MenuCloseIcon } from '@/componentv2/icons';
import Button from '@/componentv2/button/button';
import './hamburgerMenu.scss';

interface HamburgerMenuProps {
  onClick?: () => void;
  className?: string;
  isOpen?: boolean;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({
  onClick,
  className,
  isOpen = false,
}) => (
  <Button
    variant="text"
    className={`hamburger-menu ${className || ''}`.trim()}
    onClick={onClick}
    aria-label={isOpen ? 'Close menu' : 'Open menu'}
  >
    {isOpen ? (
      <MenuCloseIcon width={24} height={24} />
    ) : (
      <MenuIcon width={24} height={32} />
    )}
  </Button>
);

export default HamburgerMenu;
